$(document).ready(function() {
  $(".actualNumber").each(function(i){
    $(this).append(i+1);
  });

  var ACDC = new google.maps.LatLng(-26.110314,28.133178);
  var bounds = new google.maps.LatLngBounds();        
  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 8,
    center: ACDC,
    cenpeId: google.maps.MapTypeId.ROADMAP
  });

  // Create an array of alphabetical characters used to label the markers.
  var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  var iconDyn = {
    url: "https://cdn.shopify.com/s/files/1/1284/8335/t/2/assets/pinblueIcon.png", // url
    scaledSize: new google.maps.Size(20, 50), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };
  var iconExp = {
    url: "https://cdn.shopify.com/s/files/1/1284/8335/t/2/assets/pinredIcon.png", // url
    scaledSize: new google.maps.Size(20, 50), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };
  var iconRho = {
    url: "https://cdn.shopify.com/s/files/1/1284/8335/t/2/assets/pingreyIcon.png", // url
    scaledSize: new google.maps.Size(20, 50), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };
  var iconDist = {
    url: "https://cdn.shopify.com/s/files/1/1284/8335/t/2/assets/pingreenIcon.png", // url
    scaledSize: new google.maps.Size(20, 50), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };

  var homeMarker = new google.maps.Marker({
    position: ACDC,
    map: map,
    animation: google.maps.Animation.DROP,
    icon: iconDyn,
    title: 'ACDC Dynamics',
    optimized: false,
    zIndex:10
  });

  var contentString = '<div id="content">'+
      '<div id="siteNotice">'+
      '</div>'+
      '<h1 id="firstHeading" class="firstHeading">ACDC Dynamics Head Office</h1>'+
      '<div id="bodyContent">'+
      '<p>26 Nguni Drive, Longmeadow Estate West,<br />Edenvale, Gauteng, South Africa.<br />Tel: <span class="mapBlue"><a href="tel:+27102023300">+27 10 202 3300</a></span><br />Email: <span class="mapBlue"><a href="mailto:info@acdc.co.za">info@acdc.co.za</a></span></p>'+
      '</div>'+
      '</div>';

  var homeInfoWindow = new google.maps.InfoWindow({
    content: contentString
  });   

  var auto_inc_num = 0; //initialise value of auto incremented id to 0
  auto_inc_num++; //increment auto_inc_id by one

  var markers = [];

  // Display multiple markers on a map
  var infoWindow = new google.maps.InfoWindow(), marker, i; 

  //bounce animtation for home marker
  function toggleBounce() {
    if (homeMarker.getAnimation() !== null) {
      homeMarker.setAnimation(null);
    } else {
      homeMarker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function(){ homeMarker.setAnimation(null); }, 1500);
    }
  };

  homeInfoWindow.open(map,homeMarker);

  //functions for clicking home marker
  homeMarker.addListener('click', function() {
    infoWindow.close(map, marker);
    homeInfoWindow.open(map, homeMarker);
    map.setCenter(ACDC);
    toggleBounce();
  });

  $(".StoreLocItem").each(function() { // loop through all the divs
    //append each data entry into an array for markers
    var theNumber = auto_inc_num++; // selects the text of the num for the current element
    var theFran = $(this).find("#franType").text(); // selects the text of the fran for the current element
    var theTitle = $(this).find("#strName").text(); // selects the text of the title for the current element
    var theAdd = $(this).find("#address").text(); // selects the text of the add for the current element
    var gpsLat = $(this).find("#gpslat").text(); // selects the text of the lat for the current element
    var gpsLong = $(this).find("#gpslong").text(); // selects the text of the long for the current element
    //set datatlist for each map entry
    var optProv = $(this).find('.branchProv').text();
    var optCity = $(this).find('.branchCity').text();

    markers.push([theNumber,theFran,optCity,theTitle,gpsLat,gpsLong,theAdd]); // this adds the text of the current title to the array 

    var mapCity = {};
    var mapSuburb = {};

    function addCity(city) {
      var cities = $('#CityFilterInput');
      for(var i = 0; i < cities[0].options.length; i++) {
        if(cities[0].options[i].label == city) {
          return false;
        }
      }
      return true;
    }

    var storeoptions = $("#SearchClosest option");                    // Collect options         
    storeoptions.detach().sort(function(a,b) {               // Detach from select, then Sort
      var at = $(a).text();
      var bt = $(b).text();         
      return (at > bt)?1:((at < bt)?-1:0); 
    });
    storeoptions.appendTo("#SearchClosest"); 

    //if city exists only show 1
    if(addCity(optCity)) {
      $('#CityFilterInput').append('<option class="' + optProv + '" value="' + optCity + '">' + optCity + '</option>');
    }
    //append name to datalist
    $('#branchNameIDList').append('<option value="' + theTitle + '"></option>');
  });

  // Sets the map on all markers in the array.
  function setMapOnAll(map) {
    // Loop through our array of markers & place each one on the map  
    for( i = 0; i < markers.length; i++ ) {
      var position = new google.maps.LatLng(markers[i][4], markers[i][5]);
      var markerInfoTit = markers[i][3];
      var markerInfoFran = markers[i][1];
      var markerInfoAdd = markers[i][6];
      //bounds.extend(position);
      var franchise = markers[i][1];
      if (franchise == 'Rhomberg') {
        //set different icons for each entry type 1
        marker = new google.maps.Marker({
          position: position,
          map: map,
          icon:iconRho,
          title: markers[i][1],
          optimized: false,
          zIndex:1
        });
      } else if (franchise == 'Express') { 
        //set different icons for each entry type 2
        marker = new google.maps.Marker({
          position: position,
          map: map,
          icon:iconExp,
          title: markers[i][1],
          optimized: false,
          zIndex:2
        });
      } else if (franchise == 'DynamicsBranch') { 
        //set different icons for each entry type 3
        marker = new google.maps.Marker({
          position: position,
          map: map,
          icon:iconDyn,
          title: markers[i][1],
          optimized: false,
          zIndex:4
        });
      } else if (franchise == 'Dynamics') {
        //set different icons for each entry type 3
        marker = new google.maps.Marker({
          position: position,
          map: map,
          icon:iconDist,
          title: markers[i][1],
          optimized: false,
          zIndex:3
        });
      } else {
      }
      marker.content = "<div><h3>" + markerInfoTit + " : " + markerInfoFran + "</h3><p>" + markerInfoAdd + "</div></p></div>";

      //functions for clicking pin
      google.maps.event.addListener(marker, 'click', function (marker, i) {
        map.setZoom(16);
        map.setCenter(this.getPosition());
        homeInfoWindow.close(map, marker);
        if (this.getAnimation() !== null) {
          this.setAnimation(null);
        } else {
          this.setAnimation(google.maps.Animation.BOUNCE);
          //setTimeout(function(){ this.setAnimation(null); }, 1500);
        }
        infoWindow.open(map, this);
        infoWindow.setContent(this.content);
      });
    }
  }

  $(".StoreLocItem").each(function() { // loop through all the divs
    $(this).click(function() { 
      var index = $(this).find(".actualNumber").text();
      if(index.length) {
        //here we should move to the marker 
        map.setZoom(16);
        homeInfoWindow.close(map, homeMarker);
        var marker = markers[parseInt(index -1)];
        var markerLat = parseFloat(marker[4]);
        var markerLong = parseFloat(marker[5]);
        var markerPos = markerLat + "," + markerLong;
        var myLatlng = new google.maps.LatLng(markerLat,markerLong);
        map.setCenter(myLatlng);
        infoWindow.setOptions({ position: myLatlng });
        infoWindow.open(map);
        marker.content = "<div><h3>" + marker[3] + " : " + marker[1] + "</h3><p>" + marker[6] + "</div></p></div>";
        infoWindow.setContent(marker.content);
      }
    });
  });
  setMapOnAll(map);  

  //console.log(markers); // just to test and make sure it worked, remove once verify 

  /*************************filter button*************************/
  $('#storeLocatorFilterBtn').on('click', function() {
    $('.StoreLocItem').hide();

    //search by storename
    $('#SearchClosest').each(function () {
      var optionVal = $(this).val();
      $('.StoreLocItem').each(function() {
        var IDName = $(this).find('.StoreLocItemName').text();
        if(IDName == optionVal) {
          $(this).show();
        }
      });
    });    
  });

  function showMarker(index) {
    setMapOnAll(map);
    map.setZoom(8);
  }

  function hideMarker(index) {
    setMapOnAll(null);
  } 

  /******************************************clear filter*********************************/
  $('#storeLocatorClearBtn').on('click', function() {
    $('.StoreLocItem').show();//rebuild click function after removal
    //put back initial values
    if ( $("#ProvFilterInput option[value=All]").length == 0 ){
      $("#ProvFilterInput").prepend('<option value="All">Select Province</option>');
    } else {
    }
    if ( $("#CityFilterInput option[value=All]").length == 0 ){
      $("#CityFilterInput").prepend('<option value="All">Select City</option>');
    } else {
    }
    $('#ProvFilterInput').val('All');
    $('#CityFilterInput').val('All');
    $('#SearchClosest').val('');
    $('#SearchClosest').attr("placeholder", "STORE NAME");
    $('#SearchClosest option').prop('selected', function() {
      return this.defaultSelected;
    });

    //rebuild filter click function after removal
    $('#storeLocatorFilterBtn').bind( "click", function() {
      $('.StoreLocItem').hide();
      $('#SearchClosest').each(function () {
        var optionVal = $(this).val();
        $('.StoreLocItem').each(function() {
          var IDName = $(this).find('.StoreLocItemName').text();
          if(IDName == optionVal) {
            $(this).show();
          }
        });
      });
    });
    $('#storeLocatorFilterBtn').css('background','#444');

    //map functions on clear
    infoWindow.close(map);
    homeInfoWindow.open(map, homeMarker);
    map.setCenter(ACDC);
    map.setZoom(8);
  });

  var cityoptions = $("#CityFilterInput option");                    // Collect options         
  cityoptions.detach().sort(function(a,b) {               // Detach from select, then Sort
    var at = $(a).text();
    var bt = $(b).text();         
    return (at > bt)?1:((at < bt)?-1:0); 
  });
  cityoptions.appendTo("#CityFilterInput"); 
  $("#CityFilterInput").prepend('<option value="All">Select City</option>');
  $("#CityFilterInput")[0].options[0].selected = true;

  //on province filter change
  $('#ProvFilterInput').change(function() { 
    setTimeout(function() {      
      if ( $("#CityFilterInput option[value=All]").length == 0 ){
        $("#CityFilterInput").prepend('<option value="All" selected="selected">Select City</option>');
        $('#CityFilterInput').val('All');
      } else {
      }
    });
    $(this).find("option[value=All]").remove();
    var ind = this.selectedIndex;
    var selectedProvince = $(this).find("option:selected").text();
    var selectedCity = $("#CityFilterInput").find("option:selected").text();
    // for each store
    $(".StoreLocItem").each(function() {
      // here compare the province div contents with the value from the 
      // province dropdown
      var index = $(this).find(".actualNumber").text();
      var prov = $(this).find(".branchProv").text();

      // hide the parent div if a match is not found
      if(selectedProvince == prov) {
        homeInfoWindow.close(map, homeMarker);
        map.setZoom(7);
        var marker = markers[parseInt(index -1)];
        var markerLat = parseFloat(marker[4]);
        var markerLong = parseFloat(marker[5]);
        var markerPos = markerLat + "," + markerLong;
        var myLatlng = new google.maps.LatLng(markerLat,markerLong);
        map.setCenter(myLatlng);
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    //remove store name filter button
    $('#storeLocatorFilterBtn').unbind( "click" );
    $('#storeLocatorFilterBtn').css('background','#CCC');
  });

  //on city filter change
  $('#CityFilterInput').change(function() { 
    //$(this).find("option[value=All]").remove();
    var ind = this.selectedIndex;
    var selectedCity = $(this).find("option:selected").text();
    // for each store
    $(".StoreLocItem .branchCity").each(function() {
      // here compare the province div contents with the value from the 
      // province dropdown
      var index = $(this).parent().find(".actualNumber").text();
      var city = $(this).text();

      // hide the parent div if a match is not found
      if(selectedCity == city) {
        homeInfoWindow.close(map, homeMarker);
        map.setZoom(15);
        var marker = markers[parseInt(index -1)];
        var markerLat = parseFloat(marker[4]);
        var markerLong = parseFloat(marker[5]);
        var markerPos = markerLat + "," + markerLong;
        var myLatlng = new google.maps.LatLng(markerLat,markerLong);
        map.setCenter(myLatlng);
        $(this).parent().show();      
      } else {
        $(this).parent().hide();
      }
    });
    //remove store name filter button
    $('#storeLocatorFilterBtn').unbind( "click" );
    $('#storeLocatorFilterBtn').css('background','#CCC');
  });

  $("#CityFilterInput").chained("#ProvFilterInput");
});